import { render, staticRenderFns } from "./mbl.vue?vue&type=template&id=77564796&"
import script from "./mbl.vue?vue&type=script&lang=js&"
export * from "./mbl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77564796')) {
      api.createRecord('77564796', component.options)
    } else {
      api.reload('77564796', component.options)
    }
    module.hot.accept("./mbl.vue?vue&type=template&id=77564796&", function () {
      api.rerender('77564796', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/ae/basic/mbl.vue"
export default component.exports